import appBridge from '@/common/util/appBridge';

export default {
    data() {
        return {};
    },
    mounted() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
    },
    created() {
        this.closePull2Refresh();
    },
    methods: {
        judgeDeviceType() {
            let ua = window.navigator.userAgent.toLocaleLowerCase();
            let isIOS = /iphone|ipad|ipod/.test(ua);
            let isAndroid = /android/.test(ua);
            return {
                isIOS: isIOS,
                isAndroid: isAndroid
            };
        },
        parseLocalStroage() {
            let tmpIsOldCumtomer = localStorage.getItem('KUserisOldCustomer');
            if (tmpIsOldCumtomer) {
                if (tmpIsOldCumtomer == 'true') {
                    this.isOldCustomer = true;
                }
                if (tmpIsOldCumtomer == 'false') {
                    this.isOldCustomer = false;
                }
            } else {
                this.isOldCustomer = false;
            }

            let tmpCurrentScore = localStorage.getItem('KUserTotalScore');
            if (tmpIsOldCumtomer) {
                this.currentScore = parseInt(tmpCurrentScore);
            } else {
                this.currentScore = 0;
            }
        },
        closePull2Refresh() {
            if (window.PPDWebUI.os.inApp) {
                window.PPDWebUI.CommonService.setNavigation(this.titleBar);
                appBridge.closePullToRefresh();
            }
        },
        debounce(callback, delay = 200) {
            let timer = null;
            return () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    callback.apply(this, arguments);
                }, delay);
            };
        },
        debounce2(func, wait, immediate = true) {
            let timeout, result;
            const later = (context, args) =>
                setTimeout(() => {
                    timeout = null;
                    if (!immediate) {
                        result = func.apply(context, args);
                        context = args = null;
                    }
                }, wait);
            let debounced = function(...params) {
                if (!timeout) {
                    timeout = later(this, params);
                    if (immediate) {
                        result = func.apply(this, params);
                    }
                } else {
                    clearTimeout(timeout);
                    timeout = later(this, params);
                }
                return result;
            };
            debounced.cancel = function() {
                clearTimeout(timeout);
                timeout = null;
            };
            return debounced;
        },
        px2vw(px) {
            return `${(px / 375) * 100}vw`;
        },
        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <=
                    (window.innerHeight ||
                        document.documentElement.clientHeight) /*or $(window).height() */ &&
                rect.right <=
                    (window.innerWidth ||
                        document.documentElement.clientWidth) /*or $(window).width() */
            );
        },
        goHome() {
            if (window.PPDWebUI && window.PPDWebUI.os.inApp && window.PPDWebUI.CommonService) {
                window.PPDWebUI.CommonService.openUrl(
                    {
                        url: 'ppdloanapp://home/index'
                    },
                    function() {
                        console.log('OpenUrl调用成功');
                    },
                    function(e) {
                        console.log('OpenUrl调用失败：' + e);
                    }
                );
                // this.goClose();
            }
        },
        openLink(href) {
            if (window.PPDWebUI && window.PPDWebUI.os.inApp && window.PPDWebUI.CommonService) {
                window.PPDWebUI.CommonService.openUrl(
                    {
                        url: href
                    },
                    function() {
                        console.log('OpenUrl调用成功');
                    },
                    function(e) {
                        console.log('OpenUrl调用失败：' + e);
                    }
                );
            } else {
                window.location.href = href;
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        goClose() {
            window.PPDWebUI.CommonService.close({});
        },
        goActHome() {},
        customeTitle(titleBar) {
            if (window.PPDWebUI.os.inApp) {
                window.PPDWebUI.CommonService.setNavigation(titleBar);
            } else {
                document.title = titleBar.titleView.text;
            }
        }
        // async reportTracker2Serve(source) {
        //     let requestSource = `resume_${
        //         this.judgeDeviceType().isAndroid ? 'android' : 'ios'
        //     }_${source}`;
        //     const { Result, Content, ResultMessage } = await this.$http.getHomePageInfoV2({
        //         requestSource
        //     });
        //     if (Result === 200 && Content) {
        //         this.tracker4Home(Content);
        //     }
        // },
    }
};
